module.exports = __webpack_public_path__ + "static/laboratory.d9025d2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/laboratory.jpg
// module id = 127
// module chunks = 35783957827783 115754381975414